import { Text } from '@wix/design-system';
import React from 'react';
export const REVAMP_VOUCHER_BANNER_CONFIG = {
  'free-plan': {
    content: _ref => {
      let Trans = _ref.Trans;
      return /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "domains_search_gate.revamp.free_site.banner",
        components: [/*#__PURE__*/React.createElement(Text, {
          size: "small",
          weight: "bold"
        })]
      });
    },
    tooltip: undefined
  },
  'premium-with-voucher': {
    content: _ref2 => {
      let Trans = _ref2.Trans;
      return /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "domain_search_gate.voucher_banner",
        components: [/*#__PURE__*/React.createElement(Text, {
          size: "small",
          weight: "bold"
        })]
      });
    },
    tooltip: undefined
  },
  'premium-without-voucher': {
    content: _ref3 => {
      let Trans = _ref3.Trans;
      return /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "domain_search_gate.domain_gate.header.non_voucher"
      });
    },
    tooltip: undefined
  }
};
//# sourceMappingURL=revampVoucherBannerConfig.js.map